var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _vm.envUrl === 'https://realappdev.delhivery.com:8080/realapp/' ||
      _vm.envUrl === 'https://realappuat.delhivery.com:8080/realapp/' ||
      _vm.envUrl === 'https://realapp.delhivery.com:8080/realapp/'
  )?_c('div',{staticClass:"vendorPortalIcon"},[_c('div',{on:{"click":function($event){return _vm.redirectToVendorPortal()}}},[_c('img',{staticClass:"vendorPortalIconText",attrs:{"src":require("../../../assets/imgs/vendorPortal.png"),"alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }